const verticalAlignMap = {
    top: "flex-start",
    center: "center",
    bottom: "flex-end",
};

export default verticalAlignMap;
